import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Filter, PlusCircle } from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import {
  DatePicker,
  Descriptions,
  Modal,
  Popconfirm,
  Table,
  Tooltip as ToolPro,
  Tag,
} from "antd";
import AddJob from "../../core/modals/inventory/addjob";

import {
  deleteJobMethod,
  getAllJobMethod,
  jobStatusChangeMethod,
  getJobsForPDFMethod
} from "../../service/ApiServices";
import Swal from "sweetalert2";
import { useRef } from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const { RangePicker } = DatePicker;
import dayjs from "dayjs";
import axios from "axios";

const JobList = () => {
  const startOfCurrentMonth = dayjs().startOf("month");
  const endOfCurrentMonth = dayjs().endOf("month");

  const [selectedRange, setSelectedRange] = useState([
    startOfCurrentMonth,
    endOfCurrentMonth,
  ]);

  // NEW: fitOn and delivery date range states
  const [fitOnRange, setFitOnRange] = useState(null);
  const [deliveryRange, setDeliveryRange] = useState(null);

  const [isJobAdded, setIsJobAdded] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isStatusChanged, setIsStatusChanged] = useState(false);
  const [selectedElement, setSelectedElement] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isItemDeleted, setIsItemDeleted] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");
  const [loading, setLoading] = useState(false);
  const [printModal, setPrintModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [jobData, setJobData] = useState({
    data: [],
    page: 1,
    limit: 10,
    total: 0,
  });
  const addJobRef = useRef();

  const callHandleReset = () => {
    if (addJobRef.current) {
      addJobRef.current.handleReset();
    }
  };

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const roleName = userData?.data?.role?.roleName;

  useEffect(() => {
    if (isJobAdded || isStatusChanged || isItemDeleted) {
      const fetchJobData = async () => {
        try {
          const response = await getAllJobMethod({
            search: searchQuery,
            params: { page: jobData.page, limit: jobData.limit },
            setLoading,
            startDate: selectedRange[0].format("YYYY-MM-DD"),
            endDate: selectedRange[1].format("YYYY-MM-DD"),
            ...(fitOnRange && {
              fitOnStartDate: fitOnRange[0].format("YYYY-MM-DD"),
              fitOnEndDate: fitOnRange[1].format("YYYY-MM-DD"),
            }),
            ...(deliveryRange && {
              deliveryStartDate: deliveryRange[0].format("YYYY-MM-DD"),
              deliveryEndDate: deliveryRange[1].format("YYYY-MM-DD"),
            }),
          });
          setJobData(response);
        } catch (error) {
          console.error("Error fetching job data:", error);
        }
      };
      fetchJobData();
    }
  }, [isJobAdded, isStatusChanged, isItemDeleted]);

  useEffect(() => {

    const handler = setTimeout(async () => {
      const response = await getAllJobMethod({
        search: searchQuery,
        setLoading,
        params: {
          page: jobData.page,
          limit: jobData.limit,
          startDate: selectedRange[0].format("YYYY-MM-DD"),
          endDate: selectedRange[1].format("YYYY-MM-DD"),
          ...(fitOnRange && {
            fitOnStartDate: fitOnRange[0].format("YYYY-MM-DD"),
            fitOnEndDate: fitOnRange[1].format("YYYY-MM-DD"),
          }),
          ...(deliveryRange && {
            deliveryStartDate: deliveryRange[0].format("YYYY-MM-DD"),
            deliveryEndDate: deliveryRange[1].format("YYYY-MM-DD"),
          }),
        },
        startDate: selectedRange[0].format("YYYY-MM-DD"),
        endDate: selectedRange[1].format("YYYY-MM-DD"),
        ...(fitOnRange && {
          fitOnStartDate: fitOnRange[0].format("YYYY-MM-DD"),
          fitOnEndDate: fitOnRange[1].format("YYYY-MM-DD"),
        }),
        ...(deliveryRange && {
          deliveryStartDate: deliveryRange[0].format("YYYY-MM-DD"),
          deliveryEndDate: deliveryRange[1].format("YYYY-MM-DD"),
        }),
      });
      setJobData(response);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery, selectedRange, fitOnRange, deliveryRange]); // NEW: fitOnRange, deliveryRange added

  const handleJobAdded = () => {
    setIsJobAdded(true);
    setTimeout(() => {
      setIsJobAdded(false);
    }, 3000);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    //setSelectedJob("")
    setIsModalOpen(false);
  };

  const showModal2 = () => {
    setIsModalOpen2(true);
  };

  const handleOk2 = () => {
    setIsModalOpen2(false);
  };

  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };
  const showModal3 = async (record) => {
    console.log("Record1", record);
    const response = await axios.get("/get-job-no/" + record.jobNo);
    let job = response.data;
    console.log("job", job);
    setSelectedJob(job);
    setIsModalOpen3(true);
  };

  const handleOk3 = () => {
    setIsModalOpen3(false);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const oldandlatestvalue = [
    { value: "date", label: "Sort by Date" },
    { value: "newest", label: "Newest" },
    { value: "oldest", label: "Oldest" },
  ];
  const statusOptions = [
    { value: "choose Status", label: "Choose Status" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  const columns = [
    {
      title: "Job No",
      dataIndex: "jobNo",
      sorter: (a, b) => a.jobNo.length - b.jobNo.length,
    },
    {
      title: "Invoice No",
      dataIndex: "jobNo",
      sorter: (a, b) => a.jobNo.length - b.jobNo.length,
    },
    {
      title: "Customer",
      dataIndex: ["customer", "customerName"],
      sorter: (a, b) => a.customer.length - b.customer.length,
    },
    {
      title: "Job Date",
      dataIndex: "jobDate",
      render: (text, record) => {
        return record.jobDate ? (
          new Date(record.jobDate).toLocaleDateString()
        ) : (
          <span className="badge bg-danger">N/A</span>
        );
      },
      sorter: (a, b) => new Date(a.deliveryDate) - new Date(b.deliveryDate),
    },
    {
      title: "FitOn Date",
      dataIndex: "fitOnDate",
      render: (text, record) => {
        return record.fitOnDate ? (
          new Date(record.fitOnDate).toLocaleDateString()
        ) : (
          <span className="badge bg-danger">N/A</span>
        );
      },
      sorter: (a, b) => new Date(a.deliveryDate) - new Date(b.deliveryDate),
    },
    {
      title: "Delivery Date",
      dataIndex: "deliveryDate",
      render: (text, record) => {
        return record.deliveryDate ? (
          new Date(record.deliveryDate).toLocaleDateString()
        ) : (
          <span className="badge bg-danger">N/A</span>
        );
      },
      sorter: (a, b) => new Date(a.deliveryDate) - new Date(b.deliveryDate),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            alignContent: "start",
            justifyContent: "space-between",
            width: "120px",
          }}
        >
          <div
            className={
              text === "pending"
                ? "badge bg-warning"
                : text === "in-progress"
                  ? "badge bg-info"
                  : text === "completed"
                    ? "badge bg-success"
                    : text === "cancelled"
                      ? "badge bg-danger"
                      : text === "fit-on-ready"
                        ? "badge bg-info"
                        : ""
            }
          >
            {text}
          </div>
          <ToolPro title="Edit Status">
            <div className="add-newplus">
              <Link
                onClick={() => {
                  showModal2();
                  setSelectedElement(record);
                  setSelectedStatus(record.status);
                }}
              >
                <PlusCircle className="plus-down-add" />
              </Link>
            </div>
          </ToolPro>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to="#"
              hidden
              onClick={() => {
                setSelectedJob(record);
                showModal();
              }}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link
              className="me-2 p-2"
              to="#"
              onClick={() => {
                showModal3(record);
              }}
            >
              <i data-feather="show" className="feather-eye"></i>
            </Link>
            <Link
              className="me-2 p-2"
              to="#"
              onClick={() => {
                generatePDF(record);
              }}
            >
              <i data-feather="download" className="feather-download"></i>
            </Link>
            {roleName === "Admin" && (
              <Popconfirm
                title="Delete the job"
                description="Are you sure to delete this job?"
                onConfirm={() => {
                  deleteJobMethod({
                    jobId: record._id,
                    setIsItemDeleted,
                    showSuccessDeleted,
                  });
                }}
                onCancel={() => {
                  console.log("c");
                }}
                okText="Yes"
                cancelText="No"
              >
                <Link className="confirm-text p-2" to="#">
                  <i data-feather="trash-2" className="feather-trash-2"></i>
                </Link>
              </Popconfirm>
            )}
          </div>
        </td>
      ),
    },
  ];
  const columnsforview = [
    {
      title: "Job Type",
      dataIndex: "jobType",
      key: "jobType",
      render: (jobType) => jobType.type,
    },
    {
      title: "Quantity",
      dataIndex: "qty",
      key: "qty",
    },
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
    },
    {
      title: "Measurements",
      dataIndex: "measurements",
      key: "measurements",
    },
    {
      title: "Body Type",
      dataIndex: "bodyTypes",
      key: "bodyTypes",
      render: (bodyTypes) => (
        <ul>
          {bodyTypes?.map((body) => (
            <li key={body.id}>
              {body.name}:
              {body.values.map((value) => (
                <Tag key={value} color="blue" style={{ marginLeft: "5px" }}>
                  {value}
                </Tag>
              ))}
            </li>
          ))}
        </ul>
      ),
    },
    {
      title: "Styles",
      dataIndex: "styles",
      key: "styles",
      render: (styles) => (
        <ul>
          {styles.map((style) => (
            <li key={style._id}>
              {style.style.styleName}:
              {style.selectedValues.map((value) => (
                <Tag key={value} color="green" style={{ marginLeft: "5px" }}>
                  {value}
                </Tag>
              ))}
            </li>
          ))}
        </ul>
      ),
    },
  ];
  const showSuccessChangeStatus = () => {
    return Swal.fire({
      title: "Good job!",
      text: "You Successfully Change Status!",
      icon: "success",
    });
  };
  const showSuccessDeleted = () => {
    return Swal.fire({
      title: "Good job!",
      text: "You Successfully Cancelled Job!",
      icon: "success",
    });
  };
  const generatePDF = async (jobObj) => {
    const response = await axios.get("/get-job-no/" + jobObj.jobNo);
    let job = response.data;
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: 'a4',
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const columnWidth = (pageWidth - 40) / 2;
    const margin = 20;
    const rowHeight = 15;

    let currentY = margin;

    // Header Section
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Job Card", pageWidth / 2, currentY, { align: "center" });
    currentY += 15;

    // Horizontal Divider
    doc.setLineWidth(0.5);
    doc.line(margin, currentY, pageWidth - margin, currentY);
    currentY += 15;

    // Helper function to render two columns per row with text wrapping
    const renderTwoColumns = (fields) => {
      let columnIndex = 0;
      let rowY = currentY;

      fields.forEach((field, index) => {
        const columnX = margin + columnIndex * columnWidth;
        const maxWidth = columnWidth - 10; // Leave some padding

        // Print field
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        const fieldText = `${field.label}: ${field.value}`;

        // Check if text is too long for the column
        const textWidth = doc.getTextWidth(fieldText);

        if (textWidth > maxWidth) {
          // Split text into multiple lines
          const lines = doc.splitTextToSize(fieldText, maxWidth);
          lines.forEach((line, lineIndex) => {
            doc.text(line, columnX, rowY + (lineIndex * 12));
          });

          // If this is a long field (like measurements), move to next row
          if (field.label === "Measurements" || field.label === "Remark") {
            columnIndex = 0;
            rowY += lines.length * 12 + 5; // Add extra spacing
          } else {
            columnIndex++;
            if (columnIndex === 2 || index === fields.length - 1) {
              columnIndex = 0;
              rowY += Math.max(lines.length * 12, rowHeight);
            }
          }
        } else {
          doc.text(fieldText, columnX, rowY);
          columnIndex++;
          if (columnIndex === 2 || index === fields.length - 1) {
            columnIndex = 0;
            rowY += rowHeight;
          }
        }
      });

      return rowY;
    };

    // Loop through each job type and show job details for each (without creating new pages)
    job.jobTypesInfo.forEach((jobTypeInfo, index) => {
      // Check if we need a new page before adding content
      const estimatedContentHeight = 200; // Estimate the space needed for this job type
      if (currentY + estimatedContentHeight > pageHeight - margin) {
        doc.addPage();
        currentY = margin;
      }

      // Job Details for this specific job type
      const jobDetails = [
        { label: "Job No", value: job.jobNo || "N/A" },
        {
          label: "Job Date",
          value: new Date(job.jobDate).toLocaleDateString() || "N/A",
        },
        {
          label: "Fit On Date",
          value: new Date(job.fitOnDate).toLocaleDateString() || "N/A",
        },
        {
          label: "Final Fit On Date",
          value: new Date(job.finalFitOnDate).toLocaleDateString() || "N/A",
        },
        {
          label: "Delivery Date",
          value: new Date(job.deliveryDate).toLocaleDateString() || "N/A",
        },
        { label: "Remarks", value: job.remarks || "N/A" },
      ];

      currentY = renderTwoColumns(jobDetails);
      currentY += 15;

      // Job Type Section Header
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(`Job Type Details - ${jobTypeInfo.jobType?.type || "N/A"}`, margin, currentY);
      currentY += 10;

      doc.setLineWidth(0.2);
      doc.line(margin, currentY, pageWidth - margin, currentY);
      currentY += 10;

      const jobTypeDetails = [
        { label: "Job Type", value: jobTypeInfo.jobType?.type || "N/A" },
        { label: "Quantity", value: jobTypeInfo.qty || "N/A" },
        { label: "Tailor", value: jobTypeInfo.tailor?.full_name || "N/A" },
        { label: "Cutter", value: jobTypeInfo.cutter?.full_name || "N/A" },
      ];

      currentY = renderTwoColumns(jobTypeDetails);

      // Handle Remark separately if it's long
      if (jobTypeInfo.remark && jobTypeInfo.remark !== "N/A") {
        // Check if we need a new page for the remark
        if (currentY + 50 > pageHeight - margin) {
          doc.addPage();
          currentY = margin;
        }

        const remarkText = `Remark: ${jobTypeInfo.remark}`;
        const remarkWidth = doc.getTextWidth(remarkText);

        if (remarkWidth > pageWidth - 40) {
          const remarkLines = doc.splitTextToSize(remarkText, pageWidth - 40);
          remarkLines.forEach((line, lineIndex) => {
            doc.text(line, margin, currentY + (lineIndex * 12));
          });
          currentY += remarkLines.length * 12 + 5;
        } else {
          doc.text(remarkText, margin, currentY);
          currentY += 15;
        }
      }

      // Handle Measurements separately if it's long
      if (jobTypeInfo.measurements && jobTypeInfo.measurements !== "N/A") {

        if (currentY + 50 > pageHeight - margin) {
          doc.addPage();
          currentY = margin;
        }


        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");

        const measurementText = `Measurements: ${jobTypeInfo.measurements}`;
        const measurementWidth = doc.getTextWidth(measurementText);

        if (measurementWidth > pageWidth - 40) {
          const measurementLines = doc.splitTextToSize(measurementText, pageWidth - 40);
          measurementLines.forEach((line, lineIndex) => {
            doc.text(line, margin, currentY + (lineIndex * 14));
          });
          currentY += measurementLines.length * 14 + 5;
        } else {
          doc.text(measurementText, margin, currentY);
          currentY += 18;
        }


        doc.setFontSize(10);
      }

      // Reduced spacing before styles section
      currentY += 5;

      // Styles
      jobTypeInfo.styles.forEach((style) => {
        // Check if we need a new page
        if (currentY + rowHeight > pageHeight - margin) {
          doc.addPage();
          currentY = margin;
        }

        doc.text(
          `${style.style?.styleName || "N/A"} :(${style.selectedValues.join(
            ", "
          )})`,
          margin,
          currentY
        );
        currentY += rowHeight;
      });
      currentY += 5;

      // Body Types
      jobTypeInfo.bodyTypes.forEach((bodyType) => {
        // Check if we need a new page
        if (currentY + rowHeight > pageHeight - margin) {
          doc.addPage();
          currentY = margin;
        }

        doc.text(
          `${bodyType.name || "N/A"}: (${bodyType.values.join(", ")})`,
          margin,
          currentY
        );
        currentY += rowHeight;
      });

      // Add a line separator between job types (except for the last one)
      if (index < job.jobTypesInfo.length - 1) {
        currentY += 10;

        // Check if we have space for the separator
        if (currentY + 20 > pageHeight - margin) {
          doc.addPage();
          currentY = margin;
        } else {
          doc.setLineWidth(0.5);
          doc.line(margin, currentY, pageWidth - margin, currentY);
          currentY += 10;
        }
      }
    });

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    if (window.pdfPreviewUrl) {
      URL.revokeObjectURL(window.pdfPreviewUrl);
    }

    window.pdfPreviewUrl = pdfUrl;
    setPdfUrl(pdfUrl);

    // Show the modal after PDF is ready
    setPrintModal(true);
  };
  const handleTableChange = async (pagination) => {
    const response = await getAllJobMethod({
      search: searchQuery,
      params: { page: pagination.current, limit: pagination.pageSize },
      setLoading,
      startDate: selectedRange[0].format("YYYY-MM-DD"),
      endDate: selectedRange[1].format("YYYY-MM-DD"),
      ...(fitOnRange && {
        fitOnStartDate: fitOnRange[0].format("YYYY-MM-DD"),
        fitOnEndDate: fitOnRange[1].format("YYYY-MM-DD"),
      }),
      ...(deliveryRange && {
        deliveryStartDate: deliveryRange[0].format("YYYY-MM-DD"),
        deliveryEndDate: deliveryRange[1].format("YYYY-MM-DD"),
      }),
    });
    setJobData(response);
  };
  const onChange = (dates) => {
    if (dates === null) {
      setSelectedRange([startOfCurrentMonth, endOfCurrentMonth]);
      return;
    }
    setSelectedRange(dates);
  };

  const handlePrintDirectly = () => {
    if (!pdfUrl) return;

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    };
  };

  const handleJobSuccess = (jobData, msg) => {
    Swal.fire({
      title: "Good job!",
      text: msg,
      icon: "success",
    }).then(() => {
      if (jobData) {
        generatePDF(jobData);
      }
    });
  };

  const handleDownloadFilteredPDF = async () => {
    try {
      setLoading(true);
      const result = await getJobsForPDFMethod({
        search: searchQuery,
        setLoading,
        startDate: selectedRange[0].format("YYYY-MM-DD"),
        endDate: selectedRange[1].format("YYYY-MM-DD"),
        ...(fitOnRange && {
          fitOnStartDate: fitOnRange[0].format("YYYY-MM-DD"),
          fitOnEndDate: fitOnRange[1].format("YYYY-MM-DD"),
        }),
        ...(deliveryRange && {
          deliveryStartDate: deliveryRange[0].format("YYYY-MM-DD"),
          deliveryEndDate: deliveryRange[1].format("YYYY-MM-DD"),
        }),
      });

      if (!result?.data?.length) {
        Swal.fire({ title: "No Data", text: "No jobs found for selected filters", icon: "warning" });
        return;
      }

      await generateFilteredPDF(result.data);
    } catch (error) {
      console.error(error);
    }
  };

const generateFilteredPDF = async (jobs) => {
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    let currentY = margin;

    // Title
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Jobs Report", pageWidth / 2, currentY, { align: "center" });
    currentY += 14;

    // Filter summary
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    let filterText = `Created: ${selectedRange[0].format("YYYY-MM-DD")} to ${selectedRange[1].format("YYYY-MM-DD")}`;
    if (fitOnRange) filterText += `  |  Fit On: ${fitOnRange[0].format("YYYY-MM-DD")} to ${fitOnRange[1].format("YYYY-MM-DD")}`;
    if (deliveryRange) filterText += `  |  Delivery: ${deliveryRange[0].format("YYYY-MM-DD")} to ${deliveryRange[1].format("YYYY-MM-DD")}`;
    doc.text(filterText, pageWidth / 2, currentY + 10, { align: "center" });
    currentY += 24;

    // Build table rows — one row per jobTypeInfo
    const tableRows = [];

    jobs.forEach((job) => {
        if (!job.jobTypesInfo || job.jobTypesInfo.length === 0) {
            tableRows.push([
                job.jobNo || "N/A",
                job.customer?.customerName || "N/A",
                job.jobDate ? new Date(job.jobDate).toLocaleDateString() : "N/A",
                job.fitOnDate ? new Date(job.fitOnDate).toLocaleDateString() : "N/A",
                job.finalFitOnDate ? new Date(job.finalFitOnDate).toLocaleDateString() : "N/A",
                job.deliveryDate ? new Date(job.deliveryDate).toLocaleDateString() : "N/A",
                job.status || "N/A",
                "N/A", // job type
                "N/A", // qty
                "N/A", // tailor
                "N/A", // cutter
                "N/A", // styles
                "N/A", // measurements
                job.remarks || "N/A",
            ]);
        } else {
            job.jobTypesInfo.forEach((jobTypeInfo, index) => {
                // Normalize styles
                const stylesArray = Array.isArray(jobTypeInfo.styles)
                    ? jobTypeInfo.styles
                    : jobTypeInfo.styles?.style
                    ? jobTypeInfo.styles.style.map((s, i) => ({
                          style: s,
                          selectedValues: jobTypeInfo.styles.selectedValues?.[i] || [],
                      }))
                    : [];

                const stylesText = stylesArray
                    .map((s) => `${s.style?.styleName || "N/A"}: ${Array.isArray(s.selectedValues) ? s.selectedValues.join(", ") : s.selectedValues}`)
                    .join("\n") || "N/A";

                //sconst bodyTypesArray = Array.isArray(jobTypeInfo.bodyTypes) ? jobTypeInfo.bodyTypes : [];
                // const bodyTypesText = bodyTypesArray
                //     .map((b) => `${b.name || "N/A"}: ${b.values?.join(", ")}`)
                //     .join("\n") || "N/A";

                tableRows.push([
                    // Only show job-level info on first jobTypeInfo row
                    index === 0 ? (job.jobNo || "N/A") : "",
                    index === 0 ? (job.customer?.customerName || "N/A") : "",
                    index === 0 ? (job.jobDate ? new Date(job.jobDate).toLocaleDateString() : "N/A") : "",
                    index === 0 ? (job.fitOnDate ? new Date(job.fitOnDate).toLocaleDateString() : "N/A") : "",
                    index === 0 ? (job.finalFitOnDate ? new Date(job.finalFitOnDate).toLocaleDateString() : "N/A") : "",
                    index === 0 ? (job.deliveryDate ? new Date(job.deliveryDate).toLocaleDateString() : "N/A") : "",
                    index === 0 ? (job.status || "N/A") : "",
                    jobTypeInfo.jobType?.type || "N/A",
                    jobTypeInfo.qty || "N/A",
                    jobTypeInfo.tailor?.full_name || "N/A",
                    jobTypeInfo.cutter?.full_name || "N/A",
                    stylesText,
                    jobTypeInfo.measurements || "N/A",
                    index === 0 ? (job.remarks || "N/A") : "",
                ]);
            });
        }
    });

    doc.autoTable({
        startY: currentY,
        head: [[
            "Job No",
            "Customer",
            "Job Date",
            "Fit On",
            "Final Fit On",
            "Delivery",
            "Status",
            "Job Type",
            "Qty",
            "Tailor",
            "Cutter",
            "Styles",
            "Measurements",
            "Remarks",
        ]],
        body: tableRows,
        margin: { left: margin, right: margin },
        styles: {
            fontSize: 7,
            cellPadding: 3,
            overflow: "linebreak",
            valign: "top",
        },
        headStyles: {
            fillColor: [41, 128, 185],
            textColor: 255,
            fontStyle: "bold",
            fontSize: 7,
        },
        alternateRowStyles: {
            fillColor: [245, 245, 245],
        },
        columnStyles: {
            0:  { cellWidth: 38 },  // Job No
            1:  { cellWidth: 60 },  // Customer
            2:  { cellWidth: 45 },  // Job Date
            3:  { cellWidth: 45 },  // Fit On
            4:  { cellWidth: 45 },  // Final Fit On
            5:  { cellWidth: 45 },  // Delivery
            6:  { cellWidth: 45 },  // Status
            7:  { cellWidth: 55 },  // Job Type
            8:  { cellWidth: 22 },  // Qty
            9:  { cellWidth: 55 },  // Tailor
            10: { cellWidth: 55 },  // Cutter
            11: { cellWidth: 80 },  // Styles
            12: { cellWidth: 80 },  // Measurements
            13: { cellWidth: 60 },  // Remarks
        },
        didDrawPage: (data) => {
            // Page number at bottom
            doc.setFontSize(8);
            doc.setFont("helvetica", "normal");
            doc.text(
                `Page ${data.pageNumber}`,
                pageWidth / 2,
                doc.internal.pageSize.getHeight() - 10,
                { align: "center" }
            );
        },
    });

    const pdfBlob = doc.output("blob");
    const url = URL.createObjectURL(pdfBlob);
    if (window.pdfPreviewUrl) URL.revokeObjectURL(window.pdfPreviewUrl);
    window.pdfPreviewUrl = url;
    setPdfUrl(url);
    setPrintModal(true);
};
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Jobs</h4>
              <h6>Manage your jobs</h6>
            </div>
          </div>

          <div className="page-btn">
            <a
              className="btn btn-added"
              onClick={() => {
                showModal();
                callHandleReset();
              }}
            >
              <PlusCircle className="me-2" />
              Create Job
            </a>
          </div>
          <div className="page-btn">
            <a
              className="btn btn-added me-2"
              onClick={handleDownloadFilteredPDF}
            >
              <PlusCircle className="me-2" />
              Download PDF
            </a>
          </div>

        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search"
                    className="form-control"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <Link to="#" className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
                {/* Created Date */}
                  <div className="d-flex flex-column ms-2">
                  <small className="text-muted mb-1">Created Date</small>
                <RangePicker
                  onChange={onChange}
                  value={selectedRange}
                  format="YYYY-MM-DD"
                />
                </div>
                {/* NEW: Fit On Date */}
                <div className="d-flex flex-column ms-2">
                  <small className="text-muted mb-1">Fit On Date</small>
                  <RangePicker
                    onChange={(dates) => setFitOnRange(dates)}
                    value={fitOnRange}
                    format="YYYY-MM-DD"
                    allowClear
                  />
                </div>
                {/* NEW: Delivery Date */}
                <div className="d-flex flex-column ms-2">
                  <small className="text-muted mb-1">Delivery Date</small>
                  <RangePicker
                    onChange={(dates) => setDeliveryRange(dates)}
                    value={deliveryRange}
                    format="YYYY-MM-DD"
                    allowClear
                  />
                </div>
              </div>
            </div>
            {isFilterVisible && (
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="form-group">
                      <DatePicker
                        selected={selectedDate}
                        onChange={handleDateChange}
                        placeholderText="Choose Date"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="form-group">
                      <Select options={statusOptions} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="form-group">
                      <Select options={oldandlatestvalue} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="form-group">
                      <a className="btn btn-filters ms-auto">
                        <Filter className="me-2" /> Filter
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <Table
              columns={columns}
              dataSource={jobData?.data}
              rowKey="_id"
              pagination={{
                current: jobData?.page,
                pageSize: jobData?.limit,
                total: jobData?.total,
              }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
        <Modal
          title="PDF Preview"
          open={printModal}
          zIndex={100000}
          okText="Print"
          onOk={handlePrintDirectly}
          onCancel={() => setPrintModal(false)}
          width={800}
          style={{ top: 20 }}
          bodyStyle={{ height: "70vh", padding: 0, overflow: "hidden" }}
        >
          {pdfUrl && (
            <iframe
              src={pdfUrl}
              width="100%"
              height="100%"
              style={{ border: "none", display: "block" }}
              title="PDF Preview"
            ></iframe>
          )}
        </Modal>
      </div>
      <Modal
        title="Change Status"
        width={"25vw"}
        zIndex={100000}
        open={isModalOpen2}
        onOk={handleOk2}
        onCancel={handleCancel2}
        maskClosable={false}
        footer={null}
      >
        <div className="col-lg-12 col-sm-12 col-12">
          <div className="input-blocks">
            <select
              className="form-select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value={"pending"}>Pending</option>
              <option value={"in-progress"}>In Progress</option>
              <option value={"completed"}>Completed</option>
              <option value={"delivered"}>Delivered</option>
              <option value={"fit-on-ready"}>Fit On Ready</option>
            </select>
          </div>
        </div>
        <div className="modal-footer-btn d-flex justify-content-start">
          <button
            type="button"
            className="btn btn-cancel me-2"
            onClick={handleCancel2}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-save"
            onClick={() => {
              jobStatusChangeMethod({
                jobId: selectedElement._id,
                jobStatus: selectedStatus,
                setIsStatusChanged,
                handleCancel: handleCancel2,
                showSuccessChangeStatus,
              });
            }}
          >
            Save
          </button>
        </div>
      </Modal>
      <Modal
        title=""
        width={"75vw"}
        zIndex={100000}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => {
          //setSelectedJob("")
          setIsModalOpen(false);
        }}
        closable={false}
        maskClosable={false}
        footer={null}
      >
        <AddJob
          ref={addJobRef}
          handleCancel2={handleCancel}
          handleJobAdded={handleJobAdded}
          selectedJob={selectedJob}
          handleJobSuccess={handleJobSuccess}
        />
      </Modal>
      <Modal
        title={`Job Details - ${selectedJob.jobNo}`}
        width="75vw"
        zIndex={100000}
        open={isModalOpen3}
        onOk={handleOk3}
        onCancel={() => {
          setSelectedJob("");
          setIsModalOpen3(false);
        }}
        maskClosable={false}
        footer={null}
      >
        <Descriptions
          title="Customer Info"
          bordered
          layout="vertical"
          column={2}
          style={{ marginBottom: "20px" }}
        >
          <Descriptions.Item label="Name">
            {selectedJob?.customer?.customerName}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {selectedJob?.customer?.customerEmail}
          </Descriptions.Item>
          <Descriptions.Item label="Phone">
            {selectedJob?.customer?.customerPhone}
          </Descriptions.Item>
          <Descriptions.Item label="Address">
            {selectedJob?.customer?.customerAddress}
          </Descriptions.Item>
          <Descriptions.Item label="City">
            {selectedJob?.customer?.customerCity}
          </Descriptions.Item>
          <Descriptions.Item label="Country">
            {selectedJob?.customer?.customerCountry}
          </Descriptions.Item>
          <Descriptions.Item label="Description" span={2}>
            {selectedJob?.customer?.customerDescription}
          </Descriptions.Item>
        </Descriptions>
        {selectedJob && selectedJob.lastEditedAt && (
          <div className="alert alert-info mt-3 mb-3" role="alert">
            <div className="d-flex justify-content-between">
              <div>
                <strong>Last Edited:</strong> {
                  selectedJob.lastEditedAt
                    ? new Date(selectedJob.lastEditedAt).toLocaleString()
                    : "N/A"
                }
              </div>
              <div>
                <strong>Edited By:</strong> {
                  selectedJob.lastEditedBy ||
                  ""
                }
              </div>
            </div>
          </div>
        )}
        <Descriptions
          title="Job Info"
          bordered
          layout="vertical"
          column={2}
          style={{ marginBottom: "20px" }}
        >
          <Descriptions.Item label="Job No">
            {selectedJob?.jobNo}
          </Descriptions.Item>
          <Descriptions.Item label="Job Date">
            {selectedJob?.jobDate
              ? new Date(selectedJob?.jobDate).toLocaleDateString()
              : "----"}
          </Descriptions.Item>
          <Descriptions.Item label="Fit On Date">
            {selectedJob?.fitOnDate
              ? new Date(selectedJob?.fitOnDate).toLocaleDateString()
              : "----"}
          </Descriptions.Item>
          <Descriptions.Item label="Delivery Date">
            {selectedJob?.deliveryDate
              ? new Date(selectedJob?.deliveryDate).toLocaleDateString()
              : "----"}
          </Descriptions.Item>
          <Descriptions.Item label="Final Fit On Date">
            {selectedJob?.finalFitOnDate
              ? new Date(selectedJob?.finalFitOnDate).toLocaleDateString()
              : "----"}
          </Descriptions.Item>
          <Descriptions.Item label="Tailor">
            {selectedJob?.jobTypesInfo?.length > 0
              ? selectedJob.jobTypesInfo[0]?.tailor?.full_name
              : " No " || +selectedJob?.tailor?.last_name}
          </Descriptions.Item>
          <Descriptions.Item label="Cutter">
            {selectedJob?.jobTypesInfo?.length > 0
              ? selectedJob.jobTypesInfo[0]?.cutter?.full_name
              : "No " || " " + selectedJob?.cutter?.last_name}
          </Descriptions.Item>
          <Descriptions.Item label="Status" span={2}>
            {selectedJob?.status}
          </Descriptions.Item>
        </Descriptions>
        <Descriptions title="Job Type Info"> </Descriptions>
        <Table
          title={() => ""}
          columns={columnsforview}
          dataSource={selectedJob?.jobTypesInfo}
          rowKey={(record) => record._id}
          style={{ marginTop: "20px" }}
          pagination={false}
          bordered
        />
      </Modal>
    </div>
  );
};

export default JobList;